import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {BasketPropTypes} from "../../../utils/propTypes";

class KeyboardComponent extends Component {
    renderNavigateRightButton() {
        // Default button
        let rightButton = (<td onClick={() => this.props.navigate(1)} width="20%" className="navigation" rowSpan="4">
            <i className="fa fa-arrow-right" />
        </td>);
        // If the last tee is active, then replace default button with finish game button
        if (this.props.activeBasket.id === this.props.baskets.slice(-1)[0].id) {
            rightButton = (<td onClick={() => this.props.finishGame()} width="20%" className="navigation" rowSpan="4">
                <i className="fa fa-check" />
            </td>);
        }
        return rightButton;
    }
    render() {
        return (
            <div className="keyboard">
                <table>
                    <tbody>
                        <tr>
                            <td onClick={() => this.props.navigate(-1)} width="20%" className="navigation" rowSpan="4">
                                <i className="fa fa-arrow-left" />
                            </td>
                            <td width="20%" onClick={() => this.props.onKeyboardClick(1)}>1</td>
                            <td width="20%" onClick={() => this.props.onKeyboardClick(2)}>2</td>
                            <td width="20%" onClick={() => this.props.onKeyboardClick(3)}>3</td>
                            {this.renderNavigateRightButton()}
                        </tr>
                        <tr>
                            <td onClick={() => this.props.onKeyboardClick(4)}>4</td>
                            <td onClick={() => this.props.onKeyboardClick(5)}>5</td>
                            <td onClick={() => this.props.onKeyboardClick(6)}>6</td>
                        </tr>
                        <tr>
                            <td onClick={() => this.props.onKeyboardClick(7)}>7</td>
                            <td onClick={() => this.props.onKeyboardClick(8)}>8</td>
                            <td onClick={() => this.props.onKeyboardClick(9)}>9</td>
                        </tr>
                        <tr>
                            <td colSpan="3" style={{padding: 0}}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td
                                                width="30%"
                                                style={{borderLeft: 0}}
                                                onClick={() => this.props.changeOb(-1)}
                                            >
                                                -OB
                                            </td>
                                            <td
                                                width="30%"
                                                style={{borderRight: 0}}
                                                onClick={() => this.props.changeOb(1)}
                                            >
                                                +OB
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

KeyboardComponent.propTypes = {
    onKeyboardClick: PropTypes.func.isRequired,
    finishGame: PropTypes.func.isRequired,
    changeOb: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    activeBasket: BasketPropTypes,
    baskets: PropTypes.arrayOf(BasketPropTypes),
};

export default KeyboardComponent;



// WEBPACK FOOTER //
// ./src/apps/result_entry/components/KeyboardComponent.js